import {
  Chip,
  Grid,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import { useDashboardSectionStyles } from "./dashboardSectionStyles";
import CloseIcon from "@mui/icons-material/Close";
import AppButton from "../../components/appButton/appButton";
import { colors } from "../../app/theme/colors";
import { useTranslation } from "react-i18next";

interface Props {
  title: string;
  count: string;
  id: string;
  onClick: any;
}

export const DashboardActivitiesCard = ({
  title,
  count,
  id,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const { classes } = useDashboardSectionStyles();

  const chipData = [
    { label: "Gradjevinarstvo" },
    { label: "Drvo i Namjestaj - proizvodnja i trgovina" },
    { label: "Osiguravajuca drustva" },
    { label: "Kultura i umjetnost" },
  ];

  return (
    <motion.div
      id={id}
      onClick={onClick}
      className={classes.activitiesCardWrapper}
    >
      <Grid item md={12} className={classes.activitiesCardTitleWrapper}>
        <Typography variant="h4" className={classes.title}>
          {title}
        </Typography>
      </Grid>
      {chipData.map((chip, index) => (
        <Grid item md={12} key={index} mt={index === 0 ? 2 : 1}>
          <Chip
            label={chip.label}
            sx={{
              width: "60%",
              backgroundColor: index % 2 === 0 ? "#4D8CF557" : "#EBEBEBCC",
              color: index % 2 === 0 ? "#635F5FBA" : "#635F5FBA",
            }}
            icon={<CloseIcon className={classes.closeIconChip} />}
          />
        </Grid>
      ))}
      <Grid item md={12} mt={2}>
        <AppButton
          label={t("buttons.manageActivities")}
          color={colors.primary}
          hover={colors.primary}
          width="60%"
        />
      </Grid>
    </motion.div>
  );
};
